







































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { mathliveState } from '../stores/mathlive'
import { hideAllMathKeyboard } from '../../../lib/mathlive'
import hotkeys from 'hotkeys-js'
@Component({
  components: {}
})
export default class MathLiveComponent extends Vue {
  mathField: any = null

  @Watch('mathField', { deep: true })
  watchMathField() {
    // console.log(this.mathField.$latex());
  }

  get isShow() {
    return mathliveState.isShow
  }

  @Watch('isShow')
  watchIsShow() {
    if (this.isShow) {
      this.settupHotKeys()
      this.$modal.show('mathlive-editor')
    } else {
      this.removeHotkeys()
      this.$modal.hide('mathlive-editor')
    }
  }

  onOpened() {
    this.mathField = (window as any).MathLive.makeMathField('mathlive-editor', {
      smartMode: true,
      virtualKeyboardMode: 'onfocus',
      onContentDidChange: (mf) => {
        const latex = mf.$text()
        mathliveState.setLatex(latex)
      }
    })

    this.mathField.$latex(mathliveState.latex)
    this.mathField.$focus()

  }

  settupHotKeys() {
    hotkeys.filter = (event) => {
      return true
    }

    hotkeys('alt+enter', 'mathlive', () => {
      this.onOk()
    })

    hotkeys.setScope('mathlive')
  }

  removeHotkeys() {
    hotkeys.deleteScope('mathlive')

    // Mathliveが終わったら、Editorに戻りますので、EditorのScopeにactiveしないといけません
    hotkeys.setScope('editor')
  }

  onOk() {
    mathliveState.hide()
  }

  onCancel(){
    if (mathliveState.isShow) {
      mathliveState.cancel() 
    }
  }
}
